import { useRetailer } from '@lib/core/retailers/hooks/useRetailer';
import { useApp } from '@lib/core/service/hooks';
import { useThirdParty } from '@lib/core/service/hooks/useThirdParty';
import { setIsThirdPartyConnectShown } from '@lib/core/service/slices';
import { useModals } from '@lib/tools/modals/hooks';
import { useTypedDispatch } from '@lib/tools/views/hooks';

import { ThirdPartyConnectModal } from '@components/web/src/templates/Modals/ThirdPartyConnectModal/ThirdPartyConnectModal';

const ThirdPartyConnectModalContainer = () => {
  const dispatch = useTypedDispatch();
  const { isThirdPartyConnectModalOpened, closeAllModals } = useModals();
  const { retailerTags, retailerName, retailerPrivacyLink } = useRetailer();

  const { scenarioForThirdPartyConnectModalOpened, productCategory } = useApp();
  const { thirdPartyNewsletterTexts, handleThirdPartyAcceptance } = useThirdParty();

  const closeModalWithScenario = () => {
    if (scenarioForThirdPartyConnectModalOpened.scenario) {
      dispatch(setIsThirdPartyConnectShown(scenarioForThirdPartyConnectModalOpened.scenario));
    }
    closeAllModals();
  };

  const handleBtnClick = (acceptance: boolean) => {
    handleThirdPartyAcceptance(acceptance);
    closeModalWithScenario();
  };

  if (!scenarioForThirdPartyConnectModalOpened.scenario) {
    return null;
  }

  return (
    <ThirdPartyConnectModal
      handleBtnClick={handleBtnClick}
      hideModal={() => closeModalWithScenario()}
      isOpen={isThirdPartyConnectModalOpened}
      productCategory={productCategory}
      productName={scenarioForThirdPartyConnectModalOpened.productName}
      retailerLogo={retailerTags?.headerLogo}
      retailerName={retailerName}
      retailerPrivacyLink={retailerPrivacyLink}
      scenario={scenarioForThirdPartyConnectModalOpened.scenario}
      thirdPartyNewsletterTexts={thirdPartyNewsletterTexts}
    />
  );
};

export default ThirdPartyConnectModalContainer;
